import { useQuery } from '@tanstack/react-query'
import { fetchApi } from '@/common/lib/fetchApi'

export interface TimesheetHistoryEntry {
  id: number
  pay_period: {
    start_date: string
    end_date: string
  }
  status: 'draft' | 'submitted' | 'approved' | 'rejected'
  total_hours: number
  rejection_reason: string | null
  approved_by_employee_id: number | null
  approved_by_name: string | null
  is_admin_override: boolean
  override_at: string | null
  updated_at: string
}

export function useTimesheetHistory(status?: string) {
  const params = status ? `?status=${status}` : ''
  return useQuery({
    queryKey: ['timesheets', 'history', status ?? 'all'],
    queryFn: () => fetchApi<TimesheetHistoryEntry[]>(`/api/timesheets${params}`),
  })
}
